import React from "react";
import { Link } from "react-router-dom";
import { Button, Col, Icon, Modal, ProgressBar, Row } from "react-materialize";
import store from "store";
import $ from "jquery";
import {BASE_URL, ClearUserData, getBaseUrl} from "../Util";
import {notify} from "react-notify-toast";

class QuizHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      course_slug: null,
      url: null,
      loadingCertificate: false,
    };
    this.getCertificate = this.getCertificate.bind(this);
  }

  componentDidUpdate() {
    const { data } = this.props;

    if (this.state.data != data && data) {
      let course_slug = data.slug || data.course_slug;
      let url =
        `/course/${course_slug}` + (data.quiz_uuid ? `#${data.quiz_uuid}` : "");

      let certificate_url = data.certificate_url;
      // http for testing local
      // let certificate_url =
      //   data.certificate_url && data.certificate_url.replace("https:", "http:");

      this.setState({
        data,
        course_slug,
        url,
        certificate_url,
      });
    }
  }

  getCertificate() {
    this.setState({ loadingCertificate: true });
    this.generateCertificate();
  }

  generateCertificate() {
    let { data, certificate_url } = this.state;
    let url = certificate_url.replace("/download", "/pre-download");

    let token = store.get("auth_token");

    $.ajax(url, {
      method: "post",
      headers: { Authorization: token },
    }).then(function (res) {
        setTimeout(() => {
          $("#submitToCert").submit();
        }, 500);
    }).fail((jqXHR, textStatus, errorThrown) => {
      if (jqXHR.status === 401) {
        ClearUserData();
        const redirect_url = BASE_URL + "/login?redirect=" + window.location.pathname;
        this.props.history.push(redirect_url);
      } else if (jqXHR.status === 404) {
        notify.show("Sertifikat tidak ditemukan! Silakan hubungi admin untuk pengecekan lebih lanjut.", "warning");
      }
    });
  }

  render() {
    const { certificate_url, loadingCertificate } = this.state;
    const data = this.props.data;
    let token = store.get("auth_token").split(" ")[1]
    let course_slug = data.slug || data.course_slug;
    let url =
      `/course/${course_slug}` + (data.quiz_uuid ? `#${data.quiz_uuid}` : "");

    return (
      <div>
        <div className="pad-ml bg-white h4 border-bottom shadowed quiz-header">
          <div className="container font-narrow">
            <Row>
              <Col s={12} m={8} l={8}>
                <Link to={url} className="font-orange">
                  <Icon className="left" medium>
                    keyboard_arrow_left
                  </Icon>
                </Link>
                <span className="font-light font-black">{data.title}</span>
                <br />
                {data.chapter_title && (
                  <span className="font-small">
                    Dari{" "}
                    <Link to={url} className="font-orange">
                      {data.chapter_title}
                    </Link>
                  </span>
                )}

                {data.instructor && (
                  <span className="font-small font-black">
                    Oleh {data.instructor}
                  </span>
                )}
              </Col>

              {data.certificate_url && (
                <Col s={12} m={4} l={4}>
                  <button
                    type="submit"
                    className="btn download-btn"
                    onClick={this.getCertificate}
                  >
                    {loadingCertificate ? "Memproses..." : "Unduh Sertifikat"}
                  </button>

                  <form
                    id="submitToCert"
                    action={certificate_url}
                    method="post"
                  >
                    <input
                      type="hidden"
                      name="token"
                      value={token}
                    />
                  </form>
                </Col>
              )}
            </Row>
          </div>
        </div>
        <br />
        <Row className="loading mb-0" style={{ display: "none" }}>
          <Col s={12}>
            <ProgressBar />
          </Col>
        </Row>

        <Modal
          header="Sesi login telah berakhir"
          trigger={
            <Button
              waves="light"
              id="trigger-modal-login"
              style={{ display: "none" }}
            >
              Open
            </Button>
          }
        >
          Maaf Sesi login anda telah berakhir, silahkan login kembali pada
          sistem untuk mengunduh sertifikat
        </Modal>
      </div>
    );
  }
}
export default QuizHeader;



// WEBPACK FOOTER //
// ./src/components/Quiz/Header.js